import React, { useState } from "react";
import ModificarUsuarios from "./ModificarUsuarios";
import EliminarUsuarios from "./EliminarUsuarios";
import "../styles/Formularios.css";
import { useApiFetch } from "../utils/apiFetch";
import { useGlobal } from "../context/ContenedorGlobal";
import InputUsuarioAutocomplete from "./InputUsuarioAutocomplete";

function ConsultarUsuarios() {
    const { logout } = useGlobal();//
    const [consultaElegida, setConsultaElegida] = useState(1);
    const [idUsuario, setIdUsuario] = useState("");
    const [idCargo, setIdCargo] = useState("");
    const [idDireccion, setIdDireccion] = useState("");
    const [idSede, setIdSede] = useState("");
    const [idEdificio, setIdEdificio] = useState("");
    const [idNivel, setIdNivel] = useState("");
    const [resultados, setResultados] = useState([]);
    const [seleccionado, setSeleccionado] = useState(null);
    const [mensaje, setMensaje] = useState("");
    const [modoModificar, setModoModificar] = useState(false);
    const [modoEliminar, setModoEliminar] = useState(false);
    const [vistaActual, setVistaActual] = useState("consulta");
    const apiFetch = useApiFetch();

    const handleConsultar = async () => {
        const payload = {
            consulta_elegida: consultaElegida,
            id_usuario: idUsuario,
            id_cargo: idCargo,
            id_direccion: idDireccion,
            id_sede: idSede,
            id_edificio: idEdificio,
            id_nivel: idNivel,
        };

        try {
            const data = await apiFetch("consulta_27.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            }, logout);

            if (data.status === "ok") {
                if (data.resultados && data.resultados.length > 0) {
                    setResultados(data.resultados);
                    setMensaje("");
                    setVistaActual("resultados");
                } else {
                    setMensaje("No se encontraron registros para la consulta.");
                    setTimeout(() => setMensaje(""), 3000);
                    // Mantener vista en "consulta"
                    setVistaActual("consulta");
                }
            } else {
                setMensaje(data.message || "Error en la consulta.");
                setTimeout(() => setMensaje(""), 3000);
            }
        } catch (error) {
            setMensaje("Error al conectar con el servidor.");
            setTimeout(() => setMensaje(""), 3000);
        }
    };

    const handleExportar = async () => {
        if (resultados.length === 0) return;

        let headers = [];
        let rows = [];

        try {
            if (seleccionado === null) {
                // Exportar todos los usuarios
                headers = [
                    "ID Usuario", "Usuario", "Apellido Paterno", "Apellido Materno",
                    "Correo", "Cargo", "Dirección", "Sede", "Edificio", "Nivel"
                ];
                rows = resultados.map(u => [
                    u.id_usuario,
                    u.usuario,
                    u.a_paterno,
                    u.a_materno,
                    u.correo,
                    u.cargo,
                    u.direccion_a,
                    u.acronimo,
                    u.edificio,
                    u.nivel
                ]);
            } else {
                // Exportar solo el usuario seleccionado con datos enriquecidos
                const data = await apiFetch("consulta_27.php", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ consulta_elegida: 1, id_usuario: seleccionado })
                }, logout);

                if (data.status === "ok" && data.resultados.length > 0) {
                    const u = data.resultados[0];
                    headers = [
                        "ID Usuario", "Usuario", "Apellido Paterno", "Apellido Materno",
                        "Correo", "Cargo", "Dirección", "Sede", "Edificio", "Nivel"
                    ];
                    rows = [[
                        u.id_usuario,
                        u.usuario,
                        u.a_paterno,
                        u.a_materno,
                        u.correo,
                        u.cargo,
                        u.direccion_a,
                        u.acronimo,
                        u.edificio,
                        u.nivel
                    ]];
                } else {
                    alert("Error al consultar usuario: " + data.message);
                    return;
                }
            }

            // Generar CSV
            let csvContent = "\uFEFF";  // Caracter invisible para codificación correcta

            // Encabezados con comillas
            csvContent += headers.map(h => `"${String(h).replace(/"/g, '""')}"`).join(",") + "\r\n";

            rows.forEach(r => {
                const rowEscaped = r.map(field => {
                    let value = String(field ?? "");
                    value = value.replace(/"/g, '""');  // Escapar comillas dobles
                    return `"${value}"`;    // Encerrar siempre entre comillas
                });
                csvContent += rowEscaped.join(",") + "\r\n";
            });

            // Crear Blob y exportar
            const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "usuarios.csv");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        } catch (error) {
            alert("Error al exportar: " + error.message);
        }
    };

    // Reedirigimos a Modificar Usuarios
    if (modoModificar && seleccionado) {
        return <ModificarUsuarios idUsuarioSeleccionado={seleccionado} />;
    }

    // Si estamos en modo eliminar, renderizamos EliminarUsuarios directamente
    if (modoEliminar && seleccionado) {
        return <EliminarUsuarios idUsuarioSeleccionado={seleccionado} />;
    }

    if (vistaActual === "modificar" && seleccionado) {
        return (
            <ModificarUsuarios
                idUsuarioSeleccionado={seleccionado}
                onVolver={() => setVistaActual("resultados")}
            />
        );
    }

    if (vistaActual === "eliminar" && seleccionado) {
        return (
            <EliminarUsuarios
                idUsuarioSeleccionado={seleccionado}
                onVolver={() => setVistaActual("resultados")}
            />
        );
    }

    return (
        <div className="sesion-form">

            {vistaActual === "consulta" && (
                <>
                    {mensaje && <div className="error">{mensaje}</div>}

                    < InputUsuarioAutocomplete
                        idSeleccionado={idUsuario}
                        setIdSeleccionado={setIdUsuario}
                        label="Resguardante"
                        placeholder="Ingrese apellido paterno"
                        title="Seleccione al usuario resguardante"
                        readOnly={false}
                        maxLength={50}
                    />

                    <div className="form-buttons">
                        <button type="button" onClick={() => {
                            setConsultaElegida(1);
                            setSeleccionado(resultados.id_usuario);
                            handleConsultar();
                        }}
                        >
                            Consultar
                        </button>
                    </div>

                </>
            )}

            {vistaActual === "resultados" && (
                <>
                    {resultados.length > 0 ? (
                        <>
                            <table className="tabla-estandar seleccion-unica">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>ID Usuario</th>
                                        <th>Usuario</th>
                                        <th>A. Paterno</th>
                                        <th>A. Materno</th>
                                        <th>Correo</th>
                                        <th>Cargo</th>
                                        <th>Dirección</th>
                                        <th>Sede</th>
                                        <th>Edificio</th>
                                        <th>Nivel</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {resultados.map((r) => (
                                        <tr key={r.id_usuario}>
                                            <td data-label="Seleccionar">
                                                <input
                                                    type="checkbox"
                                                    checked={seleccionado === r.id_usuario}
                                                    onChange={() =>
                                                        setSeleccionado(seleccionado === r.id_usuario ? null : r.id_usuario)
                                                    }
                                                />
                                            </td>
                                            <td data-label="ID Usuario">{r.id_usuario}</td>
                                            <td data-label="Usuario">{r.usuario}</td>
                                            <td data-label="A. Paterno">{r.a_paterno}</td>
                                            <td data-label="A. Materno">{r.a_materno}</td>
                                            <td data-label="Correo">{r.correo}</td>
                                            <td data-label="Cargo">{r.cargo}</td>
                                            <td data-label="Dirección">{r.direccion_a}</td>
                                            <td data-label="Sede">{r.acronimo}</td>
                                            <td data-label="Edificio">{r.edificio}</td>
                                            <td data-label="Nivel">{r.nivel}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            {/* Botones globales */}
                            <div className="form-buttons">
                                <button
                                    type="button"
                                    onClick={() => setVistaActual("modificar")}
                                    disabled={!seleccionado}
                                >
                                    Modificar
                                </button>
                                <button
                                    type="button"
                                    onClick={() => setVistaActual("eliminar")}
                                    disabled={!seleccionado}
                                >
                                    Eliminar
                                </button>
                                <button
                                    type="button"
                                    className="exportar"
                                    onClick={handleExportar}
                                    disabled={!seleccionado}
                                >
                                    Exportar
                                </button>
                                <button
                                    type="button"
                                    onClick={() => setVistaActual("consulta")}
                                >
                                    Nueva consulta
                                </button>
                            </div>
                        </>
                    ) : (
                        <div >
                            <p>No se encontraron registros para la consulta.</p>
                            <button type="button" onClick={() => setVistaActual("consulta")}>
                                Volver a consultar
                            </button>
                        </div>
                    )}
                </>
            )}
        </div>
    );
}

export default ConsultarUsuarios;